module.exports = __webpack_public_path__ + "img/other01_img.d4ae2af3.png";